module.exports = __webpack_public_path__ + "static/img/3areaB_17.c2cce35.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_17.png
// module id = 1159
// module chunks = 1